import { Table as TableIcon } from 'lucide-react';
import { useWorkspaceStore } from '@/stores/workspace-store';
import { useGlobalSchemaStore } from '../global-schema-store';
import { walkTables, connectionLabel } from './_schema-helpers';
import type { SearchItem, SearchProvider } from '../types';
import type { ConnectionConfig } from '@/types';

/**
 * Every table across every cached connection. Works while disconnected
 * because the cache is read from SQLite. Picking a result opens (or focuses)
 * the data-grid tab for that table — reuse the existing tab id convention
 * so the result merges with tabs the user already has open.
 */
export const tableSearchProvider: SearchProvider = {
  id: 'tables',
  kind: 'table',
  list: (ctx) => {
    const schemas = useGlobalSchemaStore.getState().schemas;
    const connections = ctx.queryClient?.getQueryData<ConnectionConfig[]>(['connections']) ?? [];
    const items: SearchItem[] = [];

    for (const loc of walkTables(schemas)) {
      const connName = connectionLabel(connections, loc.connectionId);
      items.push({
        id: `table:${loc.connectionId}:${loc.database}:${loc.schema}.${loc.table.name}`,
        kind: 'table',
        label: loc.table.name,
        subtitle: `${loc.schema} · ${loc.database} · ${connName}`,
        icon: TableIcon,
        boost: 1.0,
        action: () => {
          const tabId = `table:${loc.connectionId}:${loc.schema}.${loc.table.name}`;
          useWorkspaceStore.getState().openTab({
            type: 'table',
            id: tabId,
            connectionId: loc.connectionId,
            database: loc.database,
            schema: loc.schema,
            table: loc.table.name,
            where: '',
            orderBy: '',
          });
        },
      });
    }

    return items;
  },
};
